import Paginate from "../../layout/Paginate";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ExpiredListingCard from "./ExpiredListingCard";

const ExpiredListing = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"Expired Listing"} />
      <Paginate
        element={(props) => <ExpiredListingCard {...props} />}
        data={new Array(134).fill(0)}
        itemsPerPage={8}
        containerClassName="flex flex-col gap-10 py-10"
      />
    </div>
  );
};

export default ExpiredListing;
